import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#A7A7B1",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M3.1 2.79h9.919c.126 0 .228.101.229.228l-.006.025a.1.1 0 0 1-.02.028l-3.747 3.6a1.52 1.52 0 0 0-.472 1.099v3.952c0 .38-.246.718-.608.834l-.184.058a.876.876 0 0 1-1.141-.834V8.178c0-.392-.152-.765-.42-1.047L2.849 3.112a.07.07 0 0 1-.022-.05l.006-.054a.27.27 0 0 1 .267-.219",
      style: {"stroke":"color(display-p3 .6543 .6543 .6951)","stroke-opacity":"1"}
    }, null, -1)
  ])))
}
export default { render: render }